module.exports = __webpack_public_path__ + "static/media/report_ii.21e34ebd.svg";